/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Save_And_ConfirmInputs */

const vi_mobile_save_and_confirm = /** @type {(inputs: Mobile_Save_And_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu & xác nhận`)
};

/**

* @param {Mobile_Save_And_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_save_and_confirm = /** @type {((inputs?: Mobile_Save_And_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Save_And_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_save_and_confirm(inputs)
});